module.exports = __webpack_public_path__ + "img/شمام-صورة.2838cc8b.png";